<template>
  <div class="p-col-12">
    <h2 class="p-col-12 labelCard">Documentos pessoais</h2>
    <div class="p-col-12 avisos">
      <p>Siga os passos a seguir para concluir essa Etapa:</p>
      <ol>
        <li class="passosSeguir">
          Atualize as informações documentais que estão desatualizadas ou
          incorretas.
        </li>
        <li class="passosSeguir">
          Ao inserir novos documentos ou atualizar as existentes, anexe cópia
          digitalizada em formato “PDF” ou imagem, com tamanho máximo de 2 MB
          cada arquivo.
        </li>
        <li class="passosSeguir">
          É obrigatório o envio de cópia digitalizada de UM documento
          comprobatório com foto, caso todos os documentos exigidos já constem e
          estejam corretos no sistema. Os documentos comprobatórios com foto
          aceitos são: RG, CNH, Identidade Profissional e Documento Nacional de
          Identificação.
        </li>
        <li
            class="passosSeguir"
            v-if="textoObrigatorio && textoObrigatorio.length > 0"
        >
          <p v-if="textoObrigatorio">{{ textoObrigatorio }}</p>
        </li>
        <li class="passosSeguir">
          Quando todos os dados estiverem corretos, selecione o botão “Finalizar
          etapa” que está no fim da página.
        </li>
      </ol>
    </div>
    <div class="p-col-12 centralizarDoc">
      <pre class="teste">{{ isCollapsed }}</pre>
      <pre class="teste">{{ colapseTeste }}</pre>
      <h2 class="p-col-12 labelCard">Documentos cadastrados</h2>
      <div class="p-col-12">
        <template>

          <div
              class="p-col-12"
              :class="[
              motivoDocsRejeitados.length > 0
                ? 'docComprobatorioNG'
                : 'docComprobatorioOK',
            ]"
              style="display: flex"
          >
            <!-- {{ sitDocComprobatorio }} -->
            <!-- {{ contador }} -->
            <Message
                v-if="contador >= 1 "
                :closable="false"
                class="p-col-12 ajusteContent"
                severity="success"
            >
              Documento comprobatório validado
            </Message>
            <Message
                v-if="verificaSeExisteDocumentoPendenteDeValidacao()"
                :closable="false"
                class="p-col-12 ajusteContent"
                severity="warn"
            >
              Documento pendente de validação
            </Message>
            <!-- <Message
              v-if="this.sitDocComprobatorio == 'rejeitado'"
              :closable="false"
              class="p-col-12 ajusteContent"
              severity="error"
            >
              Documento comprobatório rejeitado
            </Message>
            <Message
              v-if="this.sitDocComprobatorio == 'pendente'"
              :closable="false"
              class="p-col-12 ajusteContent"
              severity="info"
            >
              Aguardando envio do documento comprobatório
            </Message> -->
          </div>
        </template>
      </div>
      <div class="p-col-12 ajusteSecao">
        <div
            v-if="documentosCadastrados && documentosCadastrados.length > 0"
            class="p-col-12 ajustePanel"
        >
          <button
              v-for="(documento, index) in documentosCadastrados"
              :key="documento.idenDocumento"
              type="button"
              @click="funcaoAccord(index)"
              class="p-col-12 ajustePanel"
          >
            <Panel
                :toggleable="true"
                :collapsed="controlePanel[index]"
                class="p-col-12 ajustePanel"
            >
              <template #header class="ajusteContent">

                <span class="teste">{{ isCollapsed }}</span>
                <span>{{ documento.tipoDocumento.descTipoDocumento }} - <span  :class="verificaStatusVinculo(documento)">{{getSituacaoDocumento(documento)}}</span></span>
              </template>
              <!-- <pre>{{documento  }}</pre> -->
              <!-- <pre>{{documento.arquivosDocumento[0].flagValidado}}</pre> -->

              <Message class="p-col-12 ajusteContent" :closable="false" v-if="documento.arquivosDocumento.length > 0 &&documento.arquivosDocumento[0].statArquivoDocumento =='REJEITADO'" severity="error">
                Documento rejeitado pela chefia indicada. <strong>{{" " + verificarMotivoRejeicao(documento.arquivosDocumento[0])}}</strong>
              </Message>

              <Message
                  class="p-col-12 ajusteContent"
                  :closable="false"
                  v-if="documento.arquivosDocumento.length > 0 && documento.arquivosDocumento[0].statArquivoDocumento == 'VALIDADO'"
                  severity="success">
                Documento Comprobatório - OK
              </Message>

              <Message
                  class="p-col-12 ajusteContent"
                  :closable="false"
                  v-if="
                  documento.arquivosDocumento.length > 0 &&
                  documento.arquivosDocumento[0].statArquivoDocumento ==
                    'ENVIADO'
                    && documento.arquivosDocumento[0].flagValidado != 'S'
                    && documento.tipoDocumento.descTipoDocumento != 'PIS/PASEP'
                "
                  severity="warn"
              >
                Documento enviado para validação
              </Message>

              <!-- <Message
                class="p-col-12 ajusteContent"
                :closable="false"
                v-else-if="
                  documento.arquivosDocumento.length > 0 &&
                  documento.arquivosDocumento[0].statArquivoDocumento !=
                    'PENDENTE_ARQUIVO_NOVO' &&
                  documento.arquivosDocumento[0].statArquivoDocumento !=
                    'PENDENTE_ARQUIVO' &&
                  documento.arquivosDocumento[0].statArquivoDocumento !=
                    'REJEITADO'
                "
                severity="success"
              >
                Documento Comprobatório - Ok
              </Message> -->
              <Message
                  class="p-col-12 "
                  :closable="false"
                  v-if="documento.situacaoDocumento == 'PENDENTE'"
                  severity="error"
              >
                Todos os dados devem ser preenchidos.
                <ul>
                  <li v-for="(itemPendente) in documento.dadosPendentes" :key="itemPendente" class="dadosPendentes">{{itemPendente}}</li>
                </ul>
              </Message>

              <div class="p-col-12 ajusteContent" v-if="documento.descNumero">
                <label><strong>Número do documento: </strong>{{documento.descNumero}}</label>
              </div>
              <div class="p-col-12 ajusteContent" v-if="documento.dataExpedicao">
                <label
                ><strong>Data de expedição: </strong
                >{{ documento.dataExpedicao }}</label
                >
              </div>
              <div class="p-col-12 ajusteContent" v-if="documento.dataValidade">
                <label
                ><strong>Data de validade: </strong>
                  {{ documento.dataValidade }}</label
                >
              </div>
              <div
                  class="p-col-12 ajusteContent"
                  v-if="documento.clasCategoria"
              >
                <label
                ><strong>Categoria:</strong>
                  {{ documento.clasCategoria }}</label
                >
              </div>
              <div class="p-col-12 ajusteContent" v-if="documento.clasOrgao">
                <label
                ><strong>Classe órgão:</strong>
                  {{ documento.clasOrgao }}</label
                >
              </div>
              <!-- <div class="p-col-12 ajusteContent" v-if="documento.clasTipo">
                                <label><strong>Classe tipo:</strong> {{ documento.clasTipo }}</label>
                            </div> -->
              <div class="p-col-12 ajusteContent" v-if="documento.numrSecao">
                <label><strong>Seção:</strong> {{ documento.numrSecao }}</label>
              </div>
              <div class="p-col-12 ajusteContent" v-if="documento.descSerie">
                <label><strong>Série:</strong> {{ documento.descSerie }}</label>
              </div>
              <div class="p-col-12 ajusteContent" v-if="documento.numrZona">
                <label><strong>Zona:</strong> {{ documento.numrZona }}</label>
              </div>
              <div
                  class="p-col-12 ajusteContent"
                  v-if="documento.orgaoDocumento"
              >
                <label>
                  <strong
                      v-if="documento.tipoDocumento.siglTipoDocumento != 'IP'"
                  >Órgão expedidor:
                  </strong>
                  <strong
                      v-if="documento.tipoDocumento.siglTipoDocumento == 'IP'"
                  >Tipo:
                  </strong>
                  {{ documento.orgaoDocumento.descOrgaoDocumento }}
                </label>
              </div>
              <div class="p-col-12 p-md-6 ajusteContent" v-if="documento.uf">
                <label><strong>UF: </strong>{{ documento.uf.nomeUf }}</label>
              </div>
              <div class="p-col-12 p-md-6 ajusteContent" v-if="documento.pais">
                <label
                ><strong>País: </strong>{{ documento.pais.nomePais }}</label
                >
              </div>
              <div
                  class="p-col-12 p-md-6 ajusteContent"
                  v-if="documento.clasOrgao"
              >
                <label><strong>Orgão: </strong>{{ documento.clasOrgao }}</label>
              </div>
              <div
                  class="p-col-12 p-md-6 ajusteContent"
                  v-if="documento.descLivro"
              >
                <label><strong>Livro: </strong>{{ documento.descLivro }}</label>
              </div>
              <div
                  class="p-col-12 p-md-6 ajusteContent"
                  v-if="documento.descFolha"
              >
                <label><strong>Folha: </strong>{{ documento.descFolha }}</label>
              </div>
              <div
                  class="p-col-12 p-md-6 ajusteContent"
                  v-if="documento.cargoMilitar"
              >
                <label
                ><strong>Graduação/Posto: </strong
                >{{ documento.cargoMilitar.descSeap }}</label
                >
              </div>
              <div
                  class="p-col-12 preencher ajusteContent"
                  v-if="documento.tipoDocumento.descTipoDocumento == 'PIS/PASEP'"
              ></div>
              <div
                  class="p-col-12"
                  v-if="
                  documento.arquivosDocumento.length > 0 &&
                  documento.tipoDocumento.siglTipoDocumento != 'PISPASEP'
                "
              >
                <div
                    v-if="documento.arquivosDocumento.length > 0 && (
                    documento.arquivosDocumento[0].statArquivoDocumento ==
                      'PENDENTE_ARQUIVO_NOVO' ||
                    documento.arquivosDocumento[0].statArquivoDocumento ==
                      'PENDENTE_ARQUIVO'
             ) "
                >

                  <div class="p-grid p-fluid">
                    <Rotulo cols="12 4 4">
                      <FileUpload
                          mode="basic"
                          name="file"
                          :url="
                          inicioBaseApiUrl +
                          '/arquivodocumentos/upload/' +
                          documento.arquivosDocumento[0].idenArquivoDocumento
                        "
                          accept="application/pdf,image/*"
                          :maxFileSize="2000000"
                          :auto="true"
                          invalidFileSizeMessage="Tamanho Máximo do Arquivo Não Permitido. Tamanho Máximo de 2MB."
                          invalidFileTypeMessage="Tipo de Arquivo Não Permitido. Tipos Permitidos são Images ou PDF"
                          @before-send="antesEnvioArquivo"
                          @upload="depoisEnvioArquivo"
                          @error="erroEnvioArquivo"
                          @select="validaSelecaoArquivo"
                          chooseLabel="Anexar Arquivo"
                      />
                    </Rotulo>
                    <Rotulo
                        cols="12 4 4"
                        v-if="
                        documento.tipoDocumento.siglTipoDocumento !=
                          'PISPASEP' || documento.flagOrigem != 'SEAP'
                      "
                    >
                      <Button
                          label="Editar Documento"
                          icon="pi pi-pencil"
                          @click="editarDocumento(documento, index)"
                          class="p-button-success"
                      />
                    </Rotulo>
                    <Rotulo
                        cols="12 4 4"
                        v-if="
                        documento.flagOrigem != 'SEAP' &&
                        documento.flagObrigatorio == 'N'
                      "
                    >
                      <Button
                          label="Excluir Documento"
                          icon="pi pi-pencil"
                          @click="abrirDialogoDeletarDocumento(documento)"
                          class="p-button-danger"
                      />
                    </Rotulo>
                  </div>
                </div>
                <div v-else>
                  <div class="p-grid p-fluid">
                    <Rotulo
                        cols="12 4 3  "
                        v-if="documento.arquivosDocumento.length > 0"
                    >
                      <Button
                          label="Visualizar Arquivo"
                          icon="pi pi-file-pdf"
                          @click="visualizarDocumento(documento)"
                          class="p-button-warning"
                      />
                    </Rotulo>
                    <Rotulo cols="12 4 3 ">
                      <FileUpload
                          mode="basic"
                          name="file"
                          :url="
                          inicioBaseApiUrl +
                          '/arquivodocumentos/upload/' +
                          documento.arquivosDocumento[0].idenArquivoDocumento
                        "
                          accept="application/pdf,image/*"
                          :maxFileSize="2000000"
                          :auto="true"
                          invalidFileSizeMessage="Tamanho Máximo do Arquivo Não Permitido. Tamanho Máximo de 2MB."
                          invalidFileTypeMessage="Tipo de Arquivo Não Permitido. Tipos Permitidos são Images ou PDF"
                          @before-send="antesEnvioArquivo"
                          @upload="depoisEnvioArquivo"
                          @error="erroEnvioArquivo"
                          @select="validaSelecaoArquivo"
                          chooseLabel="Alterar Arquivo"
                      />
                    </Rotulo>
                    <Rotulo
                        cols="12 4 3 "
                        v-if="documento.arquivosDocumento.length > 0"
                    >
                      <Button
                          label="Excluir Arquivo"
                          icon="pi pi-file-pdf"
                          @click="abrirDialogoDeletar(documento)"
                          class="p-button-danger"
                      />
                    </Rotulo>
                    <Rotulo
                        cols="12 4 3"
                        v-if="
                        documento.tipoDocumento.siglTipoDocumento !=
                          'PISPASEP' || documento.flagOrigem != 'SEAP'
                      "
                    >
                      <Button
                          label="Editar Documento"
                          icon="pi pi-pencil"
                          @click="editarDocumento(documento, index)"
                          class="p-button-success"
                      />
                    </Rotulo>
                    <Rotulo
                        cols="12 4 3"
                        v-if="
                        documento.flagOrigem != 'SEAP' &&
                        documento.flagObrigatorio == 'N'
                      "
                    >
                      <Button
                          label="Excluir Documento"
                          icon="pi pi-pencil"
                          @click="abrirDialogoDeletarDocumento(documento)"
                          class="p-button-danger"
                      />
                    </Rotulo>
                  </div>
                </div>
              </div>
            </Panel>
          </button>
        </div>
        <span v-else><i>Nenhum registro encontrado</i></span>
      </div>
    </div>

    <card-seplag
        :titulo="'Inserir um novo documento'"
        cor="#00acc1"
        v-if="exibirNovoDocumento"
    >
      <div class="p-col-12" ref="inputdocumento">
        <div class="p-grid p-fluid">
          <Rotulo nome="Tipo documento" cols="12 6 4">
            <Dropdown
                v-model.lazy="novodocumento.tipoDocumento"
                :options="tipoDocumentosTipoCertidao"
                optionLabel="descTipoDocumento"
                @change="limpaCampos()"
                placeholder="Selecione..."
                v-if="!flagEditar"
            />
            <InputText
                type="text"
                v-model="novodocumento.tipoDocumento.descTipoDocumento"
                :disabled="true"
                v-else
            />
          </Rotulo>
          <Rotulo nome="Opções" cols="12 6 4"  v-if="novodocumento.tipoDocumento &&
            novodocumento.tipoDocumento.siglTipoDocumento == 'TIPOCERTIDAO'">
            <Dropdown
                v-model.lazy="tipoCertidaoSelecionada"
                :options="tipoDocumentoApenasCertidoes"
                optionLabel="descTipoDocumento"
                @change="limpaCampos()"
                placeholder="Selecione..."
            />
         </Rotulo>
        </div>
        <p v-if="novodocumento.tipoDocumento != null" class="text-danger">* Campos obrigatórios</p>

      </div>
     
        

      <div class="p-col-12">
        <!-- REGISTRO GERAL -->
        <div
            class="p-grid p-fluid"
            v-if="
            novodocumento.tipoDocumento &&
            novodocumento.tipoDocumento.siglTipoDocumento == 'RG'
          "
        >
          <Rotulo nome="Número" cols="12 3" :requerido="true">
            <InputText
                type="number"
                v-model="novodocumento.descNumero"
                ref="inputdocumento"
            />
          </Rotulo>
          <Rotulo nome="Órgão" cols="12 3" :requerido="true">
            <Dropdown
                v-model="novodocumento.orgaoDocumento"
                :options="orgaoDocumentos"
                optionLabel="siglOrgaoDocumento"
                placeholder="Selecione..."
                :filter="true"
            />
          </Rotulo>
          <Rotulo nome="UF" cols="12 3" :requerido="true">
            <Dropdown
                v-model="novodocumento.uf"
                :options="ufAll"
                optionLabel="siglUf"
                placeholder="Selecione..."
                :filter="true"
            />
          </Rotulo>
          <Rotulo nome="Data expedição" cols="12 3" :requerido="true">
            <!--<InputText type="date" v-model="novodocumento.dataExpedicao" /> -->
            <InputMask mask="99/99/9999" placeholder="dd/mm/aaaa" v-model="novodocumento.dataExpedicao"/>
          </Rotulo>
        </div>
        <!-- TÍTULO DE ELEITOR -->
        <div
            class="p-grid p-fluid"
            v-if="
            novodocumento.tipoDocumento &&
            novodocumento.tipoDocumento.siglTipoDocumento == 'TE'
          "
        >
          <Rotulo nome="Número" cols="12 3" :requerido="true">
            <InputText
                type="number"
                v-model="novodocumento.descNumero"
                ref="inputdocumento"
            />
          </Rotulo>
          <Rotulo nome="Zona" cols="12 3" :requerido="true">
            <InputText type="number" v-model="novodocumento.numrZona" />
          </Rotulo>
          <Rotulo nome="Seção" cols="12 3" :requerido="true">
            <InputText type="number" v-model="novodocumento.numrSecao" />
          </Rotulo>
          <Rotulo nome="UF" cols="12 3" :requerido="true">
            <Dropdown
                v-model="novodocumento.uf"
                :options="ufAll"
                optionLabel="siglUf"
                placeholder="Selecione..."
                :filter="true"
            />
          </Rotulo>
        </div>

        <!-- CARTEIRA DE HABILTAÇÃO (CNH) -->
        <div
            class="p-grid p-fluid"
            v-if="
            novodocumento.tipoDocumento &&
            novodocumento.tipoDocumento.siglTipoDocumento == 'CNH'
          "
        >
          <Rotulo nome="Número" cols="12 3" :requerido="true">
            <InputText
                type="number"
                v-model="novodocumento.descNumero"
                ref="inputdocumento"
            />
          </Rotulo>
          <Rotulo nome="Categoria" cols="12 3" :requerido="true">
            <!-- <InputText type="text" v-model="novodocumento.clasCategoria"   /> -->
            <Dropdown
                v-model="novodocumento.clasCategoria"
                :options="categoriaHabilitacao"
                optionValue="codgSeap"
                optionLabel="descHabilitacao"
                placeholder="Selecione a Categoria"
            />
          </Rotulo>
          <Rotulo nome="Validade" cols="12 3" :requerido="true">
            <!--<InputText type="date" v-model="novodocumento.dataValidade" />  -->
            <InputMask mask="99/99/9999" placeholder="dd/mm/aaaa" v-model="novodocumento.dataValidade"/>
          </Rotulo>
          <Rotulo nome="UF" cols="12 3" :requerido="true">
            <Dropdown
                v-model="novodocumento.uf"
                :options="ufAll"
                optionLabel="siglUf"
                placeholder="Selecione..."
                :filter="true"
            />
          </Rotulo>
        </div>

        <!-- CARTEIRA DE TRABALHO (CTPS) -->
        <div
            class="p-grid p-fluid"
            v-if="
            novodocumento.tipoDocumento &&
            novodocumento.tipoDocumento.siglTipoDocumento == 'CTPS'
          "
        >
          <Rotulo nome="Número" cols="12 4" :requerido="true">
            <InputText
                type="number"
                v-model="novodocumento.descNumero"
                ref="inputdocumento"
            />
          </Rotulo>
          <Rotulo nome="Série" cols="12 4" :requerido="true">
            <InputText type="number" v-model="novodocumento.descSerie" />
          </Rotulo>
          <Rotulo nome="UF" cols="12 4" :requerido="true">
            <Dropdown
                v-model="novodocumento.uf"
                :options="ufAll"
                optionLabel="siglUf"
                placeholder="Selecione..."
                :filter="true"
            />
          </Rotulo>
        </div>

        <!-- DOCUMENTO MILITAR -->
        <div
            class="p-grid p-fluid"
            v-if="
            novodocumento.tipoDocumento &&
            novodocumento.tipoDocumento.siglTipoDocumento == 'DM'
          "
        >
          <Rotulo nome="Número" cols="12 3" :requerido="true">
            <InputText
                type="number"
                v-model="novodocumento.descNumero"
                ref="inputdocumento"
            />
          </Rotulo>

          <Rotulo nome="Categoria" cols="12 3" :requerido="true">
            <InputText
                type="text"
                v-model="novodocumento.clasCategoria"
                @input="converteMaiuscula('novodocumento.clasCategoria')"
            />
          </Rotulo>

          <Rotulo nome="Órgão" cols="12 3" :requerido="true">
            <Dropdown
                v-model="novodocumento.orgaoDocumento"
                :options="orgaoDocumentosMilitares"
                optionLabel="siglOrgaoDocumento"
                placeholder="Selecione..."
                :filter="true"
            />
          </Rotulo>
          <Rotulo nome="UF" cols="12 3" :requerido="true">
            <Dropdown
                v-model="novodocumento.uf"
                :options="ufAll"
                optionLabel="siglUf"
                placeholder="Selecione..."
                :filter="true"
            />
          </Rotulo>
        </div>

        <!-- IDENTIDADE PROFISSIONAL -->
        <div
            class="p-grid p-fluid"
            v-if="
            novodocumento.tipoDocumento &&
            novodocumento.tipoDocumento.siglTipoDocumento == 'IP'
          "
        >
          <Rotulo nome="Número" cols="12 4" :requerido="true">
            <InputText
                type="number"
                v-model="novodocumento.descNumero"
                ref="inputdocumento"
            />
          </Rotulo>
          <Rotulo nome="Tipo" cols="12 4" :requerido="true">
            <Dropdown
                v-model="novodocumento.orgaoDocumento"
                :options="orgaoTipoIdentificacaoProf"
                optionLabel="descOrgaoDocumento"
                placeholder="Selecione..."
                :filter="true"
            />
          </Rotulo>
          <Rotulo nome="UF" cols="12 4" :requerido="true">
            <Dropdown
                v-model="novodocumento.uf"
                :options="ufAll"
                optionLabel="siglUf"
                placeholder="Selecione..."
                :filter="true"
            />
          </Rotulo>
        </div>
        <!-- PIS/PASEP -->
        <div
            class="p-grid p-fluid"
            v-if="
            novodocumento.tipoDocumento &&
            novodocumento.tipoDocumento.siglTipoDocumento == 'PISPASEP'
          "
        >
          <Rotulo nome="Número" cols="12 6" :requerido="true">
            <InputText
                type="number"
                v-model="novodocumento.descNumero"
                ref="inputdocumento"
            />
          </Rotulo>
          <Rotulo nome="Data expedição" cols="12 6" :requerido="true">
            <!--<InputText type="date" v-model="novodocumento.dataExpedicao" /> -->
            <InputMask mask="99/99/9999" placeholder="dd/mm/aaaa" v-model="novodocumento.dataExpedicao"/>
          </Rotulo>
        </div>

        <!-- DOCUMENTO NACIONAL DE IDENTIFICAÇÃO -->
        <div
            class="p-grid p-fluid"
            v-if="
            novodocumento.tipoDocumento &&
            novodocumento.tipoDocumento.siglTipoDocumento == 'DNI'
          "
        >
          <Rotulo nome="Número" cols="12 3" :requerido="true">
            <InputText
                type="number"
                v-model="novodocumento.descNumero"
                ref="inputdocumento"
            />
          </Rotulo>
          <Rotulo nome="Data expedição" cols="12 3" :requerido="true">
            <!--<InputText type="date" v-model="novodocumento.dataExpedicao" /> -->
            <InputMask mask="99/99/9999" placeholder="dd/mm/aaaa" v-model="novodocumento.dataExpedicao"/>
          </Rotulo>
          <Rotulo nome="Órgão" cols="12 3" :requerido="true">
            <Dropdown
                v-model="novodocumento.orgaoDocumento"
                :options="orgaoDocumentos"
                optionLabel="siglOrgaoDocumento"
                placeholder="Selecione..."
                :filter="true"
            />
          </Rotulo>
          <Rotulo nome="UF" cols="12 3" :requerido="true">
            <Dropdown
                v-model="novodocumento.uf"
                :options="ufAll"
                optionLabel="siglUf"
                placeholder="Selecione..."
                :filter="true"
            />
          </Rotulo>
        </div>

        <!-- REGISTRO NACIONAL DE ESTRANGEIRO -->
        <div
            class="p-grid p-fluid"
            v-if="
            novodocumento.tipoDocumento &&
            novodocumento.tipoDocumento.siglTipoDocumento == 'RNE'
          "
        >
          <Rotulo nome="Número" cols="12 3" :requerido="true">
            <InputText
                type="text"
                v-model="novodocumento.descNumero"
                ref="inputdocumento"
            />
          </Rotulo>
          <Rotulo nome="Data expedição" cols="12 3" :requerido="true">
            <!--<InputText type="date" v-model="novodocumento.dataExpedicao" /> -->
            <InputMask mask="99/99/9999" placeholder="dd/mm/aaaa" v-model="novodocumento.dataExpedicao"/>
          </Rotulo>
          <Rotulo nome="Órgão" cols="12 3" :requerido="true">
            <Dropdown
                v-model="novodocumento.orgaoDocumento"
                :options="orgaoDocumentos"
                optionLabel="siglOrgaoDocumento"
                placeholder="Selecione..."
                :filter="true"
            />
          </Rotulo>
          <Rotulo nome="UF" cols="12 3" :requerido="true">
            <Dropdown
                v-model="novodocumento.uf"
                :options="ufAll"
                optionLabel="siglUf"
                placeholder="Selecione..."
                :filter="true"
            />
          </Rotulo>
        </div>

        <!-- PASSAPORTE -->
        <div
            class="p-grid p-fluid"
            v-if="
            novodocumento.tipoDocumento &&
            novodocumento.tipoDocumento.siglTipoDocumento == 'PASS'
          "
        >
          <Rotulo nome="Número" cols="12 4" :requerido="true">
            <InputText
                type="number"
                v-model="novodocumento.descNumero"
                ref="inputdocumento"
            />
          </Rotulo>
          <Rotulo nome="Data expedição" cols="12 4" :requerido="true">
            <!-- <InputText type="date" v-model="novodocumento.dataExpedicao" />  -->
            <InputMask mask="99/99/9999" placeholder="dd/mm/aaaa" v-model="novodocumento.dataExpedicao"/>
          </Rotulo>
          <Rotulo nome="Data validade" cols="12 4" :requerido="true">
            <!--<InputText type="date" v-model="novodocumento.dataValidade" />-->
            <InputMask mask="99/99/9999" placeholder="dd/mm/aaaa" v-model="novodocumento.dataValidade"/>
          </Rotulo>
          <Rotulo nome="País" cols="12 6" :requerido="true">
            <Dropdown
                v-model="novodocumento.pais"
                :options="paisesAll"
                optionLabel="nomePais"
                placeholder="Selecione..."
                :filter="true"
            />
          </Rotulo>
          <Rotulo nome="Tipo de visto" cols="12 6" :requerido="true">
            <InputText
                type="text"
                v-model="novodocumento.clasVisto"
                @input="converteMaiuscula('novodocumento.clasVisto')"
            />
          </Rotulo>
        </div>

        <!-- REGISTRO GERAL MILITAR -->
        <div
            class="p-grid p-fluid"
            v-if="
            novodocumento.tipoDocumento &&
            novodocumento.tipoDocumento.siglTipoDocumento == 'RGMILITAR'
          "
        >
          <Rotulo nome="Número " cols="12 4" :requerido="true">
            <InputText
                type="number"
                v-model="novodocumento.descNumero"
                ref="inputdocumento"
            />
          </Rotulo>
          <Rotulo nome="Data de validade" cols="12 4" :requerido="true">
            <!--<InputText type="date" v-model="novodocumento.dataValidade" /> -->
            <InputMask mask="99/99/9999" placeholder="dd/mm/aaaa" v-model="novodocumento.dataValidade"/>
          </Rotulo>
          <Rotulo nome="Graduação/Posto" cols="12 4" :requerido="true">
            <Dropdown
                :options="graduacao"
                :filter="true"
                optionLabel="descSeap"
                v-model="novodocumento.cargoMilitar"
            />
          </Rotulo>

          <!-- <Rotulo nome="UF" cols='12 2' :requerido="true">
                        <Dropdown v-model="novodocumento.uf" :options="ufAll" optionLabel="siglUf"
                            placeholder="Selecione..." :filter="true" @change="listarCidades()" />
                    </Rotulo>
                    <Rotulo nome="Cidade" cols='12 3' :requerido="true">
                        <Dropdown v-model="novodocumento.cidade" :options="cidadesAll" optionLabel="nomeCidade"
                            placeholder="Selecione..." :filter="true" :disabled="novodocumento.uf == null || novoDocumento.uf ==''" />
                    </Rotulo> -->
        </div>

        <!-- CERTIDÃO DE NASCIMENTO -->
        <div
            class="p-grid p-fluid"
            v-if="( novodocumento.tipoDocumento && tipoCertidaoSelecionada && tipoCertidaoSelecionada.siglTipoDocumento == 'CERTNASC') ||
            (novodocumento.tipoDocumento && novodocumento.tipoDocumento.descTipoDocumento == 'Certidão de Nascimento')
          "
        >
          <Rotulo nome="Numero do Documento" cols="12 4" :requerido="novodocumento.descLivro==null|| novodocumento.descLivro==''">
            <InputMask
                v-model="novodocumento.descNumero"
                mask="9999999999 9999 9 99999 999 999999999"
            />
          </Rotulo>
          <Rotulo nome="Data expedição" cols="12 2" :requerido="true">
            <!-- <InputMask v-model="novodocumento.dataExpedicao" mask="99/99/9999" /> -->
            <!--<InputText type="date" v-model="novodocumento.dataExpedicao" /> -->
            <InputMask mask="99/99/9999" placeholder="dd/mm/aaaa" v-model="novodocumento.dataExpedicao"/>
          </Rotulo>
          <Rotulo nome="Orgão" cols="12 4" :requerido="novodocumento.descNumero==''||novodocumento.descNumero==null">
            <InputText
                type="text"
                oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                maxLength="45"
                v-model="novodocumento.clasOrgao"
                @input="converteMaiuscula('novodocumento.clasOrgao')"
            />
          </Rotulo>
          <Rotulo nome="Livro" cols="12 2" :requerido="novodocumento.descNumero==''||novodocumento.descNumero==null">
            <InputText type="number" v-model="novodocumento.descLivro" />
          </Rotulo>
          <Rotulo nome="Folha" cols="12 2" :requerido="novodocumento.descNumero==''||novodocumento.descNumero==null">
            <InputText type="number" v-model="novodocumento.descFolha" />
          </Rotulo>
          <Rotulo nome="UF" cols="12 2" >
            <Dropdown
                v-model="novodocumento.uf"
                :options="ufAll"
                optionLabel="siglUf"
                placeholder="Selecione..."
                :filter="true"
                @change="listarCidades()"
            />
          </Rotulo>
          <Rotulo nome="Cidade" cols="12 3" >
            <Dropdown
                v-model="novodocumento.cidade"
                :options="cidadesAll"
                optionLabel="nomeCidade"
                placeholder="Selecione..."
                :filter="true"
                :disabled="novodocumento.uf == null || novoDocumento.uf == ''"
            />
          </Rotulo>
        </div>

        <!-- CERTIDÃO DE CASAMENTO -->
        <div class="p-grid p-fluid"
            v-if="((novodocumento.tipoDocumento && tipoCertidaoSelecionada && tipoCertidaoSelecionada.siglTipoDocumento == 'CERTCASAM' ) ||
            (novodocumento.tipoDocumento && novodocumento.tipoDocumento.descTipoDocumento == 'Certidão de Casamento')
          )
          "
        >
          <Rotulo nome="Matricula" cols="12 4" :requerido="novodocumento.descFolha==null|| novodocumento.descFolha==''">
            <InputMask
                v-model="novodocumento.descNumero"
                mask="9999999999 9999 9 99999 999 999999999"
            />
          </Rotulo>
          <Rotulo
              nome="Data de registro de casamento"
              cols="12 2"
              :requerido="true"
          >
            <!-- <InputMask v-model="novodocumento.dataExpedicao" mask="99/99/9999" /> -->
            <!--<InputText type="date" v-model="novodocumento.dataExpedicao" /> -->
            <InputMask mask="99/99/9999" placeholder="dd/mm/aaaa" v-model="novodocumento.dataExpedicao"/>
          </Rotulo>
          <Rotulo nome="Orgão" cols="12 4" :requerido="novodocumento.descNumero==''||novodocumento.descNumero==null">
            <InputText
                type="text"
                v-model="novodocumento.clasOrgao"
                @input="converteMaiuscula('novodocumento.clasOrgao')"
            />
          </Rotulo>
          <Rotulo nome="Livro" cols="12 2" :requerido="novodocumento.descNumero==''||novodocumento.descNumero==null">
            <InputText type="number" v-model="novodocumento.descLivro" />
          </Rotulo>
          <Rotulo nome="Folha" cols="12 2" :requerido="novodocumento.descNumero==''||novodocumento.descNumero==null">
            <InputText type="number" v-model="novodocumento.descFolha" />
          </Rotulo>
          <Rotulo nome="UF" cols="12 2">
            <Dropdown
                v-model="novodocumento.uf"
                :options="ufAll"
                optionLabel="siglUf"
                placeholder="Selecione..."
                :filter="true"
                @change="listarCidades()"
            />
          </Rotulo>
          <Rotulo nome="Cidade" cols="12 3" >
            <Dropdown
                v-model="novodocumento.cidade"
                :options="cidadesAll"
                optionLabel="nomeCidade"
                placeholder="Selecione..."
                :filter="true"
                :disabled="novodocumento.uf == null || novoDocumento.uf == ''"
            />
          </Rotulo>
        </div>

      </div>
      <div class="p-col-12">
        <div class="p-grid p-fluid">
          <div class="p-col-12 p-md-2 p-md-offset-8" v-if="flagEditar">
            <Button
                class="p-button-danger"
                label="Cancelar Edição"
                @click="fecharNovoDocumento()"
                icon="pi pi-times"
                iconPos="left"
                style="margim-right: 0"
            />
          </div>
          <div class="p-col-12 p-md-2" v-if="flagEditar">
            <Button
                class="p-button-warning"
                label="Salvar Edição"
                @click="finalizarEdicaoDocumento()"
                icon="pi pi-pencil"
                iconPos="left"
                style="margim-right: 0"
            />
          </div>
          <div
              class="p-col-12 p-md-3 p-md-offset-7"
              v-if="!flagEditar && novodocumento.tipoDocumento"
          >
            <Button
                class="p-button-info"
                label="Limpar Campos"
                @click="novoDocumento()"
                icon="pi pi-times"
                iconPos="left"
                style="margim-right: 0"
            />
          </div>
          <div
              class="p-col-12 p-md-2"
              v-if="!flagEditar && novodocumento.tipoDocumento"
          >
            <Button
                class="p-button-success"
                label="Incluir"
                @click="incluirNovoDocumento()"
                icon="pi pi-check"
                iconPos="left"
            />
          </div>
          <!-- <div class="p-col-12 p-md-2 p-md-offset-10" v-if="!flagEditar && !novodocumento.tipoDocumento">
                        <Button class="p-button-success" label="Incluir"  @click="incluirNovoDocumento()"  icon="pi pi-check" iconPos="left" />
                    </div>                  -->
        </div>
      </div>
    </card-seplag>
    <div class="p-col-12">
      <div class="p-grid">
        <div class="p-col-12 p-md-2 p-md-offset-3">
          <Button label="Voltar" @click="prevPage()" icon="pi pi-angle-left" />
        </div>
        <div class="p-col-12 p-md-2">
          <Button
              label="Finalizar Etapa"
              @click="finalizarEtapaDocumento()"
              icon="pi pi-check"
              class="p-button-success"
          />
        </div>
        <div class="p-col-12 p-md-2">
          <Button
              label="Próximo"
              @click="nextPage()"
              icon="pi pi-angle-right"
              iconPos="right"
          />
        </div>
      </div>
    </div>
    <Dialog
        header="Confirmação"
        :visible.sync="exibirDialogoDeletar"
        :style="{ width: '33vw' }"
        :modal="true"
        v-if="exibirDialogoDeletar"
    >
      <div class="confirmation-content">
        <i
            class="pi pi-exclamation-triangle p-mr-3"
            style="font-size: 2rem; color: red"
        />
        <span
        >Você tem certeza que deseja <strong>EXCLUIR</strong> o anexo do
          documento
          <strong>{{ novodocumento.tipoDocumento.descTipoDocumento }}</strong
          >?</span
        >
      </div>
      <template #footer>
        <Button
            label="Fechar"
            icon="pi pi-times"
            @click="fecharDialogoDeletar"
            class="p-button-text"
        />
        <Button
            label="Sim"
            icon="pi pi-trash"
            @click="excluirArquivo()"
            class="p-button-text p-button-danger"
            autofocus
        />
      </template>
    </Dialog>

    <Dialog
        header="Confirmação"
        :visible.sync="exibirDialogoDeletarDocumento"
        :style="{ width: '33vw' }"
        :modal="true"
        v-if="exibirDialogoDeletarDocumento"
    >
      <div class="confirmation-content">
        <i
            class="pi pi-exclamation-triangle p-mr-3"
            style="font-size: 2rem; color: red"
        />
        <span
        >Você tem certeza que deseja <strong>EXCLUIR</strong> o documento
          <strong>{{ novodocumento.tipoDocumento.descTipoDocumento }}</strong
          >?</span
        >
      </div>
      <template #footer>
        <Button
            label="Fechar"
            icon="pi pi-times"
            @click="fecharDialogoDeletar"
            class="p-button-text"
        />
        <Button
            label="Sim"
            icon="pi pi-trash"
            @click="excluirDocumento()"
            class="p-button-text p-button-danger"
            autofocus
        />
      </template>
    </Dialog>

    <ExibirPDF
        v-if="pdfBase64"
        v-model="exibirPDFDocumento"
        :tamanhoTela="'70.vw'"
        :alturaTela="'30.vw'"
        :tituloTela="nomeModalPDF"
        :pdfElement="pdfBase64"
    />
  </div>
</template>

<script>
import CardSeplag from "@/template/CardSeplag.vue";
import Rotulo from "@/template/RotuloSeplag.vue";
import ExibirPDF from "@/template/CardExibirPDF.vue";
import { baseApiUrl } from "@/config/global";
//import moment from "moment";

const getDadosDocumento = () => {
  return {
    descNumero: "",
    orgaoDocumento: null,
    uf: null,
    dataExpedicao: "",
    numrZona: null,
    numrSecao: null,
    clasCategoria: null,
    dataValidade: null,
    numrSerie: null,
    descSerie: null,
    clasOrgao: null,
    //clasTipo: null,
    clasVisto: null,
    pais: null,
    tipoDocumento: null,
    arquivosDocumento: [],
    graduacao: null,
    certidoes: [],
    cargoMilitar: null,
    statDocumento: "PENDENTE",
  };
};
export default {
  name: "documentosPessoais",
  components: { CardSeplag, Rotulo, ExibirPDF },
  data: function () {
    return {
      novodocumento: getDadosDocumento(),
      orgaoDocumentos: [],
      orgaoDocumentosMilitares: [],
      orgaoTipoIdentificacaoProf: [],
      ufAll: [],
      cidadesAll: [],
      categoriaHabilitacao: [],
      tipodocumentos: [],
      tipoDocumentosTipoCertidao:[],
      tipoDocumentoApenasCertidoes:[],
      paisesAll: [],
      documentosCadastrados: [],
      flagEditar: false,
      exibirPDFDocumento: false,
      exibirNovoDocumento: true,
      exibirDialogoDeletar: false,
      exibirDialogoDeletarDocumento: false,
      inicioBaseApiUrl: baseApiUrl,
      pdfBase64: "",
      nomeModalPDF: "MODAL PDF",
      controleAccord: [],
      textoObrigatorio: null,
      isMostrarMsgAguardandoArquivo: true,
      graduacao: [],
      certidoes: [
        { name: "NASCIMENTO", value: "NASCIMENTO" },
        { name: "CASAMENTO", value: "CASAMENTO" },
      ],
      isCollapsed: false,
      colapseTeste: [],
      controlePanel: [],
      teste: null,
      teste2: null,
      formatDateView: "yyyy-MM-DD",
      formatDateHiden: "DD/MM/yyyy",
      sitDocComprobatorio: "pendente",
      motivoDocsRejeitados: [],
      contador:0,
      situacaoDocumento: null,
      tipoCertidaoSelecionada: null
    };
  },
  methods: {
    async carregarDados() {
      if (this.$store.getters.getDadosPessoa) {
        // await this.$http.get(`${baseApiUrl}/tipodocumentos/etapadocumento`).then(res2 =>{
        //     this.tipodocumentos = res2.data
        // })

        this.novodocumento = getDadosDocumento();

        this.$http
            .get(
                `${baseApiUrl}/documentos/ciclo-pessoas/${this.$store.getters.getDadosPessoa.idenCicloPessoa}`
            )
            .then((res) => {
              this.documentosCadastrados = res.data;
              this.isMostrarMsgAguardandoArquivo =
                  this.documentosCadastrados.filter(
                      (item) =>
                          (item.tipoDocumento.descTipoDocumento != "PIS/PASEP" &&
                              item.arquivosDocumento.length > 0 &&
                              item.arquivosDocumento[0].statArquivoDocumento ===
                              "ENVIADO") ||
                          (item.tipoDocumento.descTipoDocumento != "PIS/PASEP" &&
                              item.arquivosDocumento.length > 0 &&
                              item.arquivosDocumento[0].statArquivoDocumento ===
                              "VALIDADO")
                  ).length > 0
                      ? false
                      : true;
              for (let i = 0; i < this.documentosCadastrados.length; i++) {
                this.controlePanel[i] = true;
                this.colapseTeste[i] = false;
              }
            });

        // Listar Orgao Documentos
        if (this.$store.getters.getOrgaoDocumentos) {
          this.orgaoDocumentos = this.$store.getters.getOrgaoDocumentos;
        }

        // Listar Orgao Documentos Militares
        this.$http.get(`${baseApiUrl}/orgaoDocumentos/militar`).then((res) => {
          this.orgaoDocumentosMilitares = res.data;
        });

        // Listar Orgao por Tipo Identificação Profissional
        this.$http
            .get(`${baseApiUrl}/orgaoDocumentos/identificacaoprof`)
            .then((res) => {
              this.orgaoTipoIdentificacaoProf = res.data;
            });

        // Listar UF's
        if (this.$store.getters.getUf) {
          this.ufAll = this.$store.getters.getUf;
        }

        // Listar Países
        if (this.$store.getters.getPais) {
          this.paisesAll = this.$store.getters.getPais;
        }

        this.$http.get(`${baseApiUrl}/habilitacoes/all`).then((res) => {
          this.categoriaHabilitacao = res.data;
        });

        this.$http
            .get(
                `${baseApiUrl}/documentos/obrigatorios/${this.$store.getters.getDadosPessoa.idenCicloPessoa}`
            )
            .then((res) => {
              this.textoObrigatorio = res.data;
            });

        this.$http
            .get(
                `${baseApiUrl}/tipodocumentos/ciclopessoa/${this.$store.getters.getDadosPessoa.idenCicloPessoa}`
            )
            .then((res) => {
              this.tipodocumentos = res.data; 
              this.tipoDocumentosTipoCertidao = res.data.filter( item => {
                return !(item.siglTipoDocumento.includes("CERTCASAM") || item.siglTipoDocumento.includes("CERTNASC"));
              })
      
              this.tipoDocumentoApenasCertidoes = res.data.filter( item => {
                return (item.siglTipoDocumento.includes("CERTCASAM") || item.siglTipoDocumento.includes("CERTNASC"));
              })

              if(this.tipoDocumentoApenasCertidoes.length != 0){
              this.tipoDocumentosTipoCertidao.push({'siglTipoDocumento':'TIPOCERTIDAO', 'descTipoDocumento':'Tipo de Certidão'});
              }

            });

        this.$http
            .get(
                `${baseApiUrl}/documentos/patenteposto/${this.$store.getters.getDadosPessoa.idenCicloPessoa}`
            )
            .then((res) => {
              this.graduacao = res.data;
            });
      }
      this.controlePanel.fill(true);
      this.colapseTeste.fill(false);
      this.checkDocumentosComp();
    },
    verificaSeExisteDocumentoPendenteDeValidacao() {
      for (let i=0; i<this.documentosCadastrados.length; i++) {
        let documento = this.documentosCadastrados[i]
        for (let j=0; j<documento.arquivosDocumento.length; j++) {
          let arquivoDocumento = documento.arquivosDocumento[j]
          if (arquivoDocumento.statArquivoDocumento === 'ENVIADO') {
            return true
          }
        }
      }
      return false
    },
    async editarDocumento(dados) {
      window.scrollTo(1000, 1000);
      this.flagEditar = true;
      this.novodocumento = Object.assign({}, dados);

      /* this.novodocumento.dataValidade = this.novodocumento.dataValidade
      ? moment(this.novodocumento.dataValidade, "DD/MM/YYYY").format(
          this.formatDateView
        )
      : null;
     this.novodocumento.dataExpedicao = this.novodocumento.dataExpedicao
       ? moment(this.novodocumento.dataExpedicao, "DD/MM/YYYY").format(
           this.formatDateView
         )
       : null; */
      if (this.novodocumento.cargoMilitar != null) {
        this.teste = this.novodocumento.cargoMilitar;
        this.$http
            .get(
                `${baseApiUrl}/documentos/patenteposto/${this.$store.getters.getDadosPessoa.idenCicloPessoa}`
            )
            .then((res) => {
              this.graduacao = res.data;
            });
        this.graduacao.map((item) => {
          if (item.idenCargo == this.teste.idenCargo) {
            this.novodocumento.cargoMilitar = item;
          }
        });
      }
      if (this.novodocumento.uf != null) {
        this.teste2 = this.novodocumento.uf.idenUf;
        this.$http
            .get(`${baseApiUrl}/cidades/buscarPorIdenUf/${this.teste2}`)
            .then((res) => {
              this.cidadesAll = res.data;
            });
        // this.cidadesAll.map(item => {
        //      if(item.idenCidade == this.novodocumento.cidade.idenCidade ){
        //          this.novodocumento.cidade = item
        //      }
        // })
      }

      // this.novodocumento.uf =  this.novodocumento.cidade.uf
      // setTimeout(() => {
      //     this.$refs.inputdocumento.$el.focus()
      // }, 10);
    },
    verificarMotivoRejeicao(obj) {
      if (obj.motivoRejeicao != null) {
        return 'Motivo da rejeição: ' + obj.motivoRejeicao.descMotivoRejeicao
      }
    },
    finalizarEdicaoDocumento() {
      /*this.novodocumento.dataValidade = this.novodocumento.dataValidade
        ? moment(this.novodocumento.dataValidade).format(this.formatDateHiden)
        : null;
      this.novodocumento.dataExpedicao = this.novodocumento.dataExpedicao
        ? moment(this.novodocumento.dataExpedicao).format(this.formatDateHiden)
        : null;*/
      this.novodocumento.dadosPendentes = [];
      if (this.novodocumento.idenDocumento) {
        this.$http
            .put(
                `${baseApiUrl}/documentos/${this.novodocumento.idenDocumento}`,
                JSON.stringify(this.novodocumento)
            )
            .then((res) => {
              this.novodocumento = getDadosDocumento();
              this.flagEditar = false;
              this.$http
                  .get(
                      `${baseApiUrl}/documentos/ciclo-pessoas/${this.$store.getters.getDadosPessoa.idenCicloPessoa}`
                  )
                  .then((res2) => {
                    this.documentosCadastrados = res2.data;
                    this.limpaCampos();
                    this.$toast.add({
                      severity: "success",
                      summary: res.data,
                      life: 6000,
                    });
                  });
            });
      } else {
        this.$toast.add({
          severity: "error",
          summary: "Erro ao salvar alteração",
          detail:
              "Ocorreu um erro ao enviar as alterações, porfavor tente novamente!",
          life: 3000,
        });
        this.novodocumento = getDadosDocumento();
        this.flagEditar = false;
        this.limpaCampos();
      }
    },
    fecharNovoDocumento() {
      this.controlePanel.fill(true);
      this.colapseTeste.fill(false);
      this.novoDocumento();
      window.scrollTo(0, 0);
    },
    getSituacaoDocumento(documento) {
      if (documento.situacaoDocumento === 'CONCLUIDO') {
        return 'Concluído';
      }
      if (documento.situacaoDocumento === 'PENDENTE') {
        return 'Pendente';
      }
      return 'Pendente de validação';
    },
    verificaStatusVinculo(documento) {
      if (documento.situacaoDocumento === 'CONCLUIDO') {
        return 'statusVinculoConcluido';
      }
      if (documento.situacaoDocumento === 'PENDENTE') {
        return 'statusVinculoIrregular';
      }
      return 'statusVinculoPendente';
    },
    novoDocumento() {
      this.novodocumento = getDadosDocumento();
      this.novodocumento.dadosPendentes = [];
      this.flagEditar = false;
      this.novodocumento.tipoDocumento = this.tipodocumentos[0];
      this.limpaCampos();
    },
    limpaCampos() {
      this.novodocumento.descNumero = null;
      this.novodocumento.orgaoDocumento = null;
      this.novodocumento.uf = null;
      this.novodocumento.dataExpedicao = "";
      this.novodocumento.numrZona = null;
      this.novodocumento.numrSecao = null;
      this.novodocumento.clasCategoria = null;
      this.novodocumento.dataValidade = "";
      this.novodocumento.descSerie = null;
      this.novodocumento.clasOrgao = null;
      //this.novodocumento.clasTipo = null
      this.novodocumento.clasVisto = null;
      this.novodocumento.pais = null;
    },
    incluirNovoDocumento() {
      /*this.novodocumento.dataValidade = this.novodocumento.dataValidade
        ? moment(this.novodocumento.dataValidade).format(this.formatDateHiden)
        : null;
      this.novodocumento.dataExpedicao = this.novodocumento.dataExpedicao
        ? moment(this.novodocumento.dataExpedicao).format(this.formatDateHiden)
        : null;*/
      this.novodocumento.dadosPendentes = [];
     if( this.novodocumento.tipoDocumento &&
       this.novodocumento.tipoDocumento.siglTipoDocumento == 'TIPOCERTIDAO'){
       this.novodocumento.tipoDocumento = this.tipoCertidaoSelecionada;
     }
      this.$http
          .post(
              `${baseApiUrl}/documentos/${this.$store.getters.getDadosPessoa.idenCicloPessoa}`,
              JSON.stringify(this.novodocumento)
          )
          .then((res) => {
            this.novodocumento = getDadosDocumento();
            this.flagEditar = false;
            this.$http
                .get(
                    `${baseApiUrl}/documentos/ciclo-pessoas/${this.$store.getters.getDadosPessoa.idenCicloPessoa}`
                )
                .then((res2) => {
                  this.documentosCadastrados = res2.data;
                  this.limpaCampos();
                  this.$http
                      .get(
                          `${baseApiUrl}/tipodocumentos/ciclopessoa/${this.$store.getters.getDadosPessoa.idenCicloPessoa}`
                      )
                      .then((res3) => {
                        this.tipodocumentos = res3.data;
                        this.$toast.add({
                          severity: "success",
                          summary: res.data,
                          life: 6000,
                        });
                      });
                });
          });
      this.controlePanel.fill(true);
      this.colapseTeste.fill(false);
    },
    abrirDialogoDeletarDocumento(documento) {
      this.novodocumento = Object.assign({}, documento);
      this.exibirDialogoDeletarDocumento = true;
    },
    abrirDialogoDeletar(documento) {
      this.novodocumento = Object.assign({}, documento);
      this.exibirDialogoDeletar = true;
    },
    fecharDialogoDeletar() {
      this.novoDocumento();
      this.exibirDialogoDeletarDocumento = false;
      this.exibirDialogoDeletar = false;
    },
    deletarDocumento() {
      this.$http
          .delete(`${baseApiUrl}/documentos/${this.novodocumento.idenDocumento}`)
          .then((res) => {
            this.$http
                .get(
                    `${baseApiUrl}/documentos/ciclo-pessoas/${this.$store.getters.getDadosPessoa.idenCicloPessoa}`
                )
                .then((res2) => {
                  this.documentosCadastrados = res2.data;
                  this.exibirDialogoDeletar = false;
                  this.$http
                      .get(
                          `${baseApiUrl}/tipodocumentos/ciclopessoa/${this.$store.getters.getDadosPessoa.idenCicloPessoa}`
                      )
                      .then((res3) => {
                        this.tipodocumentos = res3.data;
                        this.fecharDialogoDeletar();
                        this.$toast.add({
                          severity: "success",
                          summary: res.data,
                          detail: "",
                          life: 6000,
                        });
                      });
                });
          });
    },
    antesEnvioArquivo(event) {
      event.xhr.setRequestHeader(
          "Authorization",
          this.$store.getters.getToken.token_type +
          " " +
          this.$store.getters.getToken.access_token
      );
      this.$store.commit("setLoader", true);
    },
    depoisEnvioArquivo(event) {
      this.$http
          .get(
              `${baseApiUrl}/documentos/ciclo-pessoas/${this.$store.getters.getDadosPessoa.idenCicloPessoa}`
          )
          .then((res) => {
            this.documentosCadastrados = res.data;
            this.$toast.add({
              severity: "success",
              summary: "Arquivo salvo!",
              detail: event.xhr.response,
              life: 5000,
            });
            this.carregarDados();
            this.$store.commit("setLoader", false);
          });
    },
    erroEnvioArquivo(event) {
      let response = JSON.parse(event.xhr.response);
      if (response.length > 0) {
        for (let i = 0; i < response.length; i++) {
          if (response[i].msgUsuario) {
            this.$toast.add({
              severity: "error",
              summary: "Erro ao enviar o arquivo",
              detail: response[i].msgUsuario,
              life: 5000,
            });
          } else {
            this.$toast.add({
              severity: "error",
              summary: "Erro ao enviar o arquivo",
              detail: response[i],
              life: 5000,
            });
          }
        }
      } else {
        this.$toast.add({
          severity: "error",
          summary: "Erro ao enviar o arquivo",
          detail: response,
          life: 5000,
        });
      }
      this.$store.commit("setLoader", false);
    },
    validaSelecaoArquivo(event) {
      if (event.files && event.files.length > 0) {
        if (event.files[0].size > 2000000) {
          this.$toast.add({
            severity: "error",
            summary: "Erro ao enviar o arquivo",
            detail:
                "O tamanho do arquivo excede 2 MBs, por favor informe um arquivo com até 2 MBs.",
            life: 5000,
          });
        }
      }
    },
    nomeDocumentoAccord(dados) {
      if (
          dados.arquivosDocumento.length > 0 &&
          dados.arquivosDocumento[0].statArquivoDocumento ==
          "PENDENTE_ARQUIVO_NOVO"
      ) {
        if (dados.tipoDocumento.siglTipoDocumento != "PISPASEP") {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    finalizarEtapaDocumento() {
      this.$http
          .put(
              `${baseApiUrl}/documentos/concluir/${this.$store.getters.getDadosPessoa.idenCicloPessoa}`
          )
          .then((res) => {
            this.$http
                .get(
                    `${baseApiUrl}/ciclopessoafases/ciclopessoa/${this.$store.getters.getCicloPessoa[0].idenCicloPessoa}`
                )
                .then((res2) => {
                  let flag =
                      this.$store.getters.getDadosPessoa.pessoa.flagServidor != "S";
                  let etapaCliclo = res2.data.filter(function (etapa) {
                    if (
                        etapa.fase.statFase != "INATIVO" &&
                        etapa.fase.descFase != "TERMO_ACEITE"
                    ) {
                      if (etapa.fase.descFase == "VINCULOS" && flag) {
                        return false;
                      } else {
                        return true;
                      }
                    } else {
                      return false;
                    }
                  });
                  this.$store.commit("setEtapasCiclo", JSON.stringify(etapaCliclo));
                  this.$http
                      .get(
                          `${baseApiUrl}/ciclopessoas/resumo/${this.$store.getters.getIdenPessoa}`
                      )
                      .then((res3) => {
                        this.$store.commit(
                            "setCicloPessoa",
                            JSON.stringify(res3.data)
                        );
                        if (
                            this.$store.getters.getCicloPessoa.length > 0 &&
                            this.$store.getters.getCicloPessoa[0].vinculosAtivos
                                .length > 0 &&
                            this.$store.getters.getCicloPessoa[0].vinculosAtivos[0]
                                .numrProtocolo
                        ) {
                          this.$router.push({ name: "recadastramento" });
                        } else {
                          setTimeout(() => {
                            this.$toast.add({ severity: 'success', summary: res.data, life: 10000 });
                        }, 0)
                          this.$router.push({ name: "RECAD_ENDERECO_VIEW" });
                        }
                      });
                });
          });
    },
    visualizarDocumento(dado) {
      this.$http
          .get(
              `${baseApiUrl}/arquivosrecad/download/${dado.arquivosDocumento[0].arquivoRecad.idenArquivo}`
          )
          .then((res3) => {
            this.pdfBase64 = res3.data;
            this.nomeModalPDF = dado.tipoDocumento.descTipoDocumento;
            this.exibirPDFDocumento = true;
          });
    },
    excluirArquivo() {
      this.$http
          .put(
              `${baseApiUrl}/arquivodocumentos/excluir/${this.novodocumento.arquivosDocumento[0].idenArquivoDocumento}`
          )
          .then(() => {
            this.exibirDialogoDeletar = false;
            this.$toast.add({
              severity: "success",
              summary: "Anexo excluído com sucesso!",
              detail: "",
              life: 6000,
            });
            this.carregarDados();
            this.novodocumento = getDadosDocumento();
          });
    },
    excluirDocumento() {
      this.$http
          .delete(`${baseApiUrl}/documentos/${this.novodocumento.idenDocumento}`)
          .then(() => {
            this.exibirDialogoDeletarDocumento = false;
            this.$toast.add({
              severity: "success",
              summary: "Documento excluído com sucesso!",
              detail: "",
              life: 6000,
            });
            this.carregarDados();
          });
    },
    listarCidades() {
        this.$http
            .get(
                `${baseApiUrl}/cidades/buscarPorIdenUf/${this.novodocumento.uf.idenUf}`
            )
            .then((res) => {
              this.cidadesAll = res.data;
            });
    },
    converteMaiuscula(atributo) {
      if (atributo == "novodocumento.clasOrgao") {
        this.novodocumento.clasOrgao = this.specialCharacterBlock(
            this.novodocumento.clasOrgao.toUpperCase()
        );
      } else if (atributo == "novodocumento.clasVisto") {
        this.novodocumento.clasVisto = this.specialCharacterBlock(
            this.novodocumento.clasVisto.toUpperCase()
        );
      } else if (atributo == "novodocumento.clasCategoria") {
        this.novodocumento.clasCategoria = this.specialCharacterBlock(
            this.novodocumento.clasCategoria.toUpperCase()
        );
      }
    },
    nextPage() {
      this.$router.push({ name: "RECAD_ENDERECO_VIEW" });
    },
    prevPage() {
      this.$router.push({ name: "RECAD_DADOS_PESSOAIS_VIEW" });
    },
    fechaTodosAccord() {
      for (let i = 0; i < this.controlePanel.length; i++) {
        this.controlePanel[i] = false;
      }
    },
    funcaoAccord(index) {
      this.controlePanel[index] = this.isCollapsed;
      this.isCollapsed = !this.isCollapsed;
      this.controlePanel[index] = this.colapseTeste[index];
      this.colapseTeste[index] = !this.colapseTeste[index];
    },
    specialCharacterBlock(str) {
      str = str.replace(/[àáâãäå]/g, "a");
      str = str.replace(/[ÀÁÂÃÄÅ]/g, "A");

      str = str.replace(/[éèêë]/g, "e");
      str = str.replace(/[ÉÈÊË]/g, "E");

      str = str.replace(/[íìîï]/g, "i");
      str = str.replace(/[ÍÌÎÏ]/g, "I");

      str = str.replace(/[óòõôö]/g, "o");
      str = str.replace(/[ÓÒÕÔÖ]/g, "O");

      str = str.replace(/[úùûü]/g, "u");
      str = str.replace(/[ÚÙÛÜ]/g, "U");

      str = str.replace(/[ç]/g, "c");
      str = str.replace(/[Ç]/g, "C");

      str = str.replace(/[!@#$%¬&*=+/?|°ºª§´^~¨()_"]/g, "");

      return str;
    },
    checkDocumentosComp() {
      this.documentosCadastrados.map((element) => {
        if (element.arquivosDocumento[0].flagValidado == 'S'
        ) {
          this.contador += 1
        }
      });
    },
  },
  mounted() {
    this.carregarDados();
  },
};
</script>

<style>
/* .docPendente   .p-accordion-header-link{
    background-color: rgb(255, 129, 129) !important;
}

.docPendente   .p-accordion-header-link:hover{
    background-color: rgb(243, 65, 65) !important ;
}

.docConcluido  .p-accordion-header-link{
    background-color: rgba(132, 194, 132, 0.616) !important;
}

.docConcluido   .p-accordion-header-link:hover{
    background-color: rgb(11, 180, 11) !important ;
} */

.docConcluido {
  color: #43a047;
  margin-top: 2px;
  margin-left: 15px;
}

.docPendente {
  color: #f2bf27;
  margin-top: 2px;
  margin-left: 15px;
}

.statusVinculoPendente {
  color: #f2bf27;
  margin-right: 3px;
}

.statusVinculoIrregular {
  color: #f27777;
  margin-right: 3px;
}

.statusVinculoConcluido {
  color: #43a047;
  margin-right: 3px;
}

.avisos {
  background-color: rgb(231 232 125 / 84%);
  /* Red */
  color: #000000;
  border-radius: 12px;
}

.passosSeguir {
  list-style-type: decimal-leading-zero;
  margin-left: 3vw;
}

.dotPendente2 {
  width: 2vw;
  color: #f2bf27;
  display: inline-block;
  font-size: 2vw !important;
}

.dotConcluido {
  width: 2vw;
  color: #43a047;
  display: inline-block;
  font-size: 2vw !important;
}

.dotIrregular {
  width: 2vw;
  color: #f27777;
  display: inline-block;
  font-size: 2vw !important;
}

.alinhamento {
  margin-left: 10px;
}

.avisos {
  background-color: rgb(231 232 125 / 84%);
  /* Red */
  color: #000000;
  border-radius: 12px;
  margin-bottom: 10px;
}

.labelCard {
  border-bottom: 1px solid #d5d5d5;
  padding: 0.1em;
  font-size: 24px;
  margin-bottom: 10px;
}

.passosSeguir {
  list-style-type: decimal-leading-zero;
  margin-left: 3vw;
}

.rejeitadoArquivo {
  color: orange;
}

.cardDocuemtno {
  padding: 12px;
}

.preencher {
  height: 100%;
}

.alertErrorMsg {
  height: 4.4rem;
}

.centralizarDoc {
  justify-content: center;
  justify-items: center;
}

.alinhamentoStatus {
  margin-left: -80%;
}

@media screen and (max-width: 40em) {
  .passosSeguir {
    margin-left: 9vw;
    text-align: justify;
  }

  .cardDocuemtno {
    padding: 1px;
  }

  .preencherCardCarteiraTrabalho {
    height: 7% !important;
  }

  .alinhamentoStatus {
    display: none;
  }
}
</style>

<style scoped>
.ajusteSecao {
  margin-top: 20px;
}

.ajustaBotao {
  /* justify-items: ; */
  justify-content: space-between;
  margin-top: 20px;
}

.ajustePanel {
  margin-top: -15px;
}

.ajusteContent {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start !important;
  justify-items: flex-start;
  margin-right: 1500px;
}

.teste {
  display: none;
}

.dadosPendentes{
  text-align: start;
  list-style-type: disc;
  margin-left: 2vw;
}

.text-danger{
  color: #FF0000 ;

}
</style>